/**
 * アプリケーション内で使用されるカスタムイベント名の定数定義
 */

// エラー関連イベント
export const ERROR_EVENTS = {
  GLOBAL: 'error:global',
  FORBIDDEN_API: 'error:forbiddenApi'
} as const;

// 認証関連イベント
export const AUTH_EVENTS = {
  LOGOUT: 'auth:logout',
  UNAUTHORIZED: 'auth:unauthorized',
  REFRESH_SESSION: 'auth:refreshSession',
  NO_ORGANIZATION_ACCESS: 'auth:noOrganizationAccess'
} as const;

// クエリ関連イベント
export const QUERY_EVENTS = {
  INVALIDATE_ACTIVE: 'query:invalidateActive'
} as const;

// ナビゲーション関連イベント
export const NAVIGATION_EVENTS = {
  HISTORY_BACK: 'navigation:historyBack'
} as const;